
export default {
  props: ["open", "data", "guest", "cart"],
  name: "shippingCost",
};
